import './productMenu.scss';

import { useEffect, useState } from 'react';
import { Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

import CartLoad from '@/resources/components/global/CartLoad';
import { useDevice } from '@/resources/hooks/useDevice';
import { usePageBreakpoints } from '@/resources/hooks/usePageBreakpoints';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { getProductsmenu, getProductsMenuDetails } from '@/routes/productsMenu';
import { createErrorMessage } from '@/services/handlers';
import { ProductMenu } from '@/store/ducks/ProductsMenu/type';

import { ProductsWrapper } from './components/ProductsWrapper';

export default function Default({ catalog }: { catalog?: { id: number; name: string } }) {
  const { order } = useWebContext();
  const [productMenu, setProductMenu] = useState<ProductMenu>();
  const [loading, setLoading] = useState<boolean>(false);
  const [image, setImage] = useState<{
    url: string | null;
    styles: { width: string; height: string };
  }>();
  const { breakpoints } = usePageBreakpoints();
  const { device } = useDevice();

  useEffect(() => {
    setLoading(true);
    if (catalog?.id && order?.dst_shop_id) {
      getProductsMenuDetails(catalog.id)
        .then((data) => {
          setImage(
            device === 'desktop'
              ? {
                  url: data?.desktop_image_url,
                  styles: { width: '100%', height: '200px' },
                }
              : {
                  url: data?.mobile_image_url,
                  styles: { width: '100%', height: '180px' },
                },
          );
          getProductsmenu(catalog.id, order?.dst_shop_id as number).then((products) => {
            setProductMenu({ ...data, products });
          });
        })
        .catch((err) => {
          toast(createErrorMessage(err, 'Erro ao exibir Cátalogo', true), { type: 'warning' });
        })
        .finally(() => setLoading(false));
    }
  }, [catalog?.id, device, order?.dst_shop_id]);

  return loading ? (
    <CartLoad />
  ) : (
    <div>
      <Container fluid>
        <Row className="justify-content-center">
          <Col {...breakpoints} className="breakpoint-page">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Pagina Inicial</Breadcrumb.Item>
              <Breadcrumb.Item active>{catalog?.name}</Breadcrumb.Item>
            </Breadcrumb>

            <div>
              <img
                src={image?.url ?? productMenu?.desktop_image_url}
                alt={catalog?.name}
                style={image?.styles}
              />
            </div>
            <ProductsWrapper ProductMenu={productMenu} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
